import { trpc } from '@/data-loaders';

export const useSchoolsFilteredByUser = (year: number) => {
  return trpc.schoolUnit.getSchoolsFilteredByUser.useQuery(
    { year },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: !!year,
    },
  );
};
